import type { Ranking } from './tournament.model';

// Same payload as Player.rankings (RankingDTO on the backend, with the sport nested rather than
// flattened onto the ranking). Kept as an alias so a DTO reshape is a one-file edit.
export type UserRanking = Ranking;

export enum SubscriptionRole {
  OWNER = 'OWNER',
  FUTURE_OWNER = 'FUTURE_OWNER',
  PLAYER = 'PLAYER',
  MANAGER = 'MANAGER',
  INSTRUCTOR = 'INSTRUCTOR',
  PENDING_DEBT = 'PENDING_DEBT',
  ADMIN = 'ADMIN',
}

export interface UserSubscription {
  id: string;
  subscriptionType: string;
  mercadoPagoSubscriptionId: string;
  subscriptionRole: SubscriptionRole;
}

export interface User {
  id?: string;
  email: string;
  username: string;
  name: string;
  gender: string;
  birthdate: string;
  cellphone: string;
  rankings: UserRanking[];
  roles: string[];
  phoneToken: string;
  hasMercadoPagoCredentials: boolean;
  playerSubscription: UserSubscription;
  managerSubscription: UserSubscription;
  profileImageUrl: string;
  termsAccepted: boolean;
}
